"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPortalDetails = exports.mockPortalProperty = void 0;
var domain_1 = require("@genoa/domain");
exports.mockPortalProperty = {
    property_id: 7,
    name: 'Portal Property Mocked',
    identity_biller_id: 4,
    location: {
        address_line_1: '123 Main St',
        address_line_2: '',
        city: 'Chicago',
        state: 'IL',
        postal_code: '60610',
        latitude: 42.0339357,
        longitude: -87.6721867,
    },
    integration_type: domain_1.IntegrationType.PORTAL,
    billing_integration_type: '',
    public_id: 'portalproperty1',
    status: domain_1.BillerPropertyStatus.ACTIVE,
    pmc_id: 3,
    pmc_name: 'Portal Test PMC',
    external_pmc_id: null,
    external_property_id: 'portalproperty1',
    portal_id: 2,
    created_at: '2023-02-14',
    updated_at: '2023-02-14',
    current_tier: null,
    qualified_tier: null,
};
exports.mockPortalDetails = {
    portal_name: 'mocked_portal',
    display_name: 'Mocked Portal',
    login_url: 'https://portalproperty1.getflex.com/login',
    forgot_password_url: 'https://portal1.getflex.com/forgot',
    register_url: 'https://portal1.getflex.com/register',
    logo_url: 'https://assets.getflex.com/portal1.png',
    color_logo_url: 'https://assets.getflex.com/portal1-color.png',
    background_color: '#000111',
    foreground_color: '#FFFFFF',
    username_field_name: 'Username',
    password_field_name: 'Password',
};
